export default "__VITE_ASSET__a2260110__"